module.exports = __webpack_public_path__ + "static/media/export.3f41adae.svg";